<template>
    <div id="lodgementRun" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-9 col-sm-5 col-lg-5 my-auto">
                                <h5 class="modal-title">Lodgement Run</h5>
                            </div>
                            <div class="col-3 col-sm-7 my-auto">
                                <div>
                                    <div>
                                        <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal"
                                                    id="closeLodgementRun" aria-label="Close"></i></a></span>
                                    </div>
                                    <div>
                                        <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                <span class="fa-stack fa-2x fsm float-right">
                                    <i class="far fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                </span>
                            </router-link> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row text-center mt-3">
                            <div class="col-sm-12">
                                <p class="d-inline">Do you wish to start a lodgement run?</p>
                            </div>
                            <div class="col-sm-12 no-pad">
                                <button type="submit" class="btn btn-hc w-40 mt-4 mr-2 mb-3"
                                    @click="startLodgementRun" :disabled="submitStatus == 'PENDING'">Yes</button>
                                <button type="submit" class="btn btn-hc w-40 mt-4 mr-2 mb-3" data-dismiss="modal"
                                     aria-label="Close">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      submitStatus: null,
    };
  },
  methods: {
    startLodgementRun() {
      this.submitStatus = "PENDING";
      this.$http
        .post(
          "https://" +
            Vue.config.honeycomb.ddbot.domain +
            "/api/v1/lodgementRun",
          {},
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = "OK";
          this.$snotify.success(`Success! Lodgement run started.`);
          document.getElementById("closeLodgementRun").click();
        })
        .catch((error) => {
          // Error
          this.submitStatus = "ERROR";
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
  },
};
</script>
